import React from 'react';
import { useJourney } from '~/hooks/journey';

const Welcome = React.lazy(() =>
  import('../Welcome').then(({ Welcome }) => ({ default: Welcome })),
);
const IntroCategory = React.lazy(() =>
  import('../IntroCategory').then(({ IntroCategory }) => ({
    default: IntroCategory,
  })),
);

export const IntroWelcomeWrapper: React.FC = () => {
  const { hasPreJourney } = useJourney();
  return hasPreJourney ? <Welcome /> : <IntroCategory />;
};
